import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { FormContractModel } from "./form";
import { IOptionsProps } from "../../../interfaces";

interface IModalMessageModelProps {
    onCancel: Function;
    onSave: Function;
    defaultId?: string;
    openModal: boolean;
    backgroundVisible?: boolean;
}

const texts: any = {
    title: {
        new: "Cadastro de Modelo de contrato",
        edit: "Informações do Modelo de contrato",
    },
    subTitle: {
        new: "Informe os dados do modelo de contrato",
        edit: "Segue abaixo as informações do modelo de contrato",
    },
};

export const ModalContractModel: React.FC<IModalMessageModelProps> = (props) => {
    const { onCancel, onSave, openModal, backgroundVisible, defaultId } = props;

    const { api } = useApi();
    const { theme, notify } = useGlobal();

    const [loading, setLoading] = useState(!!defaultId);
    const [defaultData, setDefaultData] = useState<any>(null);

    const [accommodationOptions, setAccommodationOptions] = useState<{ label: string; value: string }[]>([]);
    const [accommodationGroupOptions, setAccommodationGroupOptions] = useState<{ label: string; value: string }[]>([]);

    const searchAccommodations = useCallback(async () => {
        try {
            const { data } = await api.get("/accommodations/all");

            const _data = data.map((item: { id: string; name: string, stays_id: string }) => ({
                label: item?.stays_id + " - " + item.name,
                value: String(item.id),
            }));

            setAccommodationOptions(_data);

            return _data as IOptionsProps[];
        } catch (error) {
            console.error("Error fetching accommodations:", error);
            return [];
        }
    }, []);

    const searchAccommodationsGroups = useCallback(async () => {
        const { data } = await api.get("/accommodations-groups/all");

        const _data = data.map((item: { id: string; name: string }) => ({
            label: item.name,
            value: String(item.id),
        }));

        setAccommodationGroupOptions(_data);

        return _data as IOptionsProps[];
    }, []);

    const searchContractModel = useCallback(async () => {
        const [accommodations, accommodationsGroups] = await Promise.all([
            searchAccommodations(),
            searchAccommodationsGroups(),
        ]);

        if (defaultId) {
            setLoading(true);
            try {
                const { data } = await api.get(`/contract-models/${defaultId}`);
                const _data = data as any;

                _data.message = data.text;
                _data.group_id = accommodationsGroups.find((item) => item.value === data.group_id) ?? null;
                _data.accommodation_id = accommodations.find((item) => item.value === data.accommodation_id) ?? null;

                setDefaultData({ ..._data });
            } catch (err) {
                notify("Erro ao buscar o modelo de contrato", "error");
                onCancel();
            } finally {
                setLoading(false);
            }
        }
    }, [defaultId]);

    useEffect(() => {
        searchContractModel();
    }, [searchContractModel]);

    return (
        <ModalGeneric
            backgroundVisible={backgroundVisible}
            open={openModal}
            onClose={() => { }}
        >
            <Container theme={theme}>
                <ModalHeader
                    title={texts.title[defaultId ? "edit" : "new"]}
                    subTitle={texts.subTitle[defaultId ? "edit" : "new"]}
                    onCancel={() => onCancel()}
                    theme={theme}
                />
                <ContentOrLoading type="wave" loading={loading} theme={theme}>
                    {!loading && (
                        <FormContractModel
                            onSave={onSave}
                            onCancel={onCancel}
                            defaultData={defaultData}
                            accommodationOptions={accommodationOptions}
                            groupOptions={accommodationGroupOptions}
                        />
                    )}
                </ContentOrLoading>
            </Container>
        </ModalGeneric>
    );
};
